module.exports = __webpack_public_path__ + "img/standard-icon5.1b89e34.svg";